import { ReactNode } from 'react';
import createSafeContext from '@paradigm/utils/src/createSafeContext';
import { createPositionsWebSocket } from '#/positions/websocket/ws';
import {
  PositionsNotification,
  PositionsWebSocket,
  WebSocketStatus,
} from '#/positions/entities/types';
import { useWebsocket } from './abstractions/useWebsocket';

export const [usePositionsWebsocket, PositionsWebsocketContext] =
  createSafeContext<PositionsWebSocket>('PositionsWebsocketContext');
export const [usePositionsWSStatus, PositionsWebsocketStatusContext] =
  createSafeContext<WebSocketStatus>('PositionsWebsocketStatusContext');

interface Props {
  children: ReactNode;
}

export function PositionsWebsocketProvider({ children }: Props) {
  const { ws, status } = useWebsocket<
    PositionsWebSocket,
    PositionsNotification
  >(createPositionsWebSocket);
  return (
    <PositionsWebsocketContext value={ws}>
      <PositionsWebsocketStatusContext value={status}>
        {children}
      </PositionsWebsocketStatusContext>
    </PositionsWebsocketContext>
  );
}
